import React from "react";
import { Svg } from "assets";
import { Loop, Odometer } from "./primitives";

/** Top nav — logo + RCM anchor + "2 months free" CTA. */
export const Nav = ({ ctaHref }) => {
  return (
    <nav className="abp-wrap abp-nav">
      <div className="abp-nav__brand">
        <Svg.FooterLogo />
      </div>
      <div className="abp-nav__right">
        <a href="#demo" className="abp-nav__link">RCM services</a>
        <a href={ctaHref} target="_blank" rel="noopener noreferrer" className="abp-btn-primary abp-btn-primary--sm">2 months free <span className="abp-arrow">&rarr;</span></a>
      </div>
    </nav>
  );
};

/** Optional RCM services band — copy column + managed-billing queue artwork. */
export const RcmSection = ({ rcm, demoHref }) => {
  return (
    <section id="demo" data-screen-label="Optional RCM services" className="abp-rcm">
      <div className="abp-rcm__band">
        <div className="abp-rcm__col">
          <div className="abp-rcm__eyebrow">{rcm.eyebrow}</div>
          <h2 className="abp-rcm__title">{rcm.title}</h2>
          <p className="abp-rcm__body">{rcm.body}</p>
          <ul className="abp-rcm__list">
            {rcm.bullets.map((text, i) => (
              <li key={i} className="abp-rcm__item"><span className="abp-rcm__mark"><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" /></svg></span><span className="abp-rcm__text">{text}</span></li>
            ))}
          </ul>
          <a href={demoHref} target="_blank" rel="noopener noreferrer" className="abp-rcm-cta">{rcm.cta}</a>
        </div>
        <div data-anim="yes" className="abp-rcm__queue">
          <div className="abp-rcm__queuehead">
            <span className="abp-card-label">MANAGED BILLING QUEUE</span>
            <span className="abp-rcm__teamtag">RCM TEAM</span>
          </div>
          <div className="abp-rcm__work">
            <div className="abp-flex1">
              <div className="abp-stat-label abp-stat-label--slate">YOUR OPEN WORK</div>
              <Odometer size={34} dur={10} mt={2} tones={["navy", "navy", "navy", "navy", "green"]} rows={["14", "9", "5", "2", "0"]} />
            </div>
            <div className="abp-rcm__avatars">
              <span className="abp-rcm__av1">RM</span>
              <span className="abp-rcm__av2">SK</span>
              <span className="abp-rcm__av3">DP</span>
            </div>
          </div>
          <div className="abp-stack-8">
            <div className="abp-row-lg"><span className="abp-rcm__itemlabel">Denials worked &amp; appealed</span><span className="abp-rcm__statusslot"><span className="abp-dashed abp-op0"></span><span className="abp-circle-check"><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></span></span></div>
            <div className="abp-row-lg"><span className="abp-rcm__itemlabel">Payments posted &amp; reconciled</span><span className="abp-rcm__statusslot"><Loop anim="e2o" dur={10} as="span" className="abp-dashed"></Loop><Loop anim="e2i" dur={10} as="span" className="abp-circle-check"><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></Loop></span></div>
            <div className="abp-row-lg"><span className="abp-rcm__itemlabel">Follow-up on aging claims</span><span className="abp-rcm__statusslot"><Loop anim="e3o" dur={10} as="span" className="abp-dashed"></Loop><Loop anim="e3i" dur={10} as="span" className="abp-circle-check"><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></Loop></span></div>
          </div>
          <div className="abp-rcm__foot"><span className="abp-rcm__foottext">Same system, handled for you</span><span className="abp-rcm__footaccent">managed</span></div>
        </div>
      </div>
    </section>
  );
};

/** Closing call-to-action band. */
export const FinalCta = ({ finalCta, ctaHref, demoHref }) => {
  return (
    <section data-screen-label="Final CTA" className="abp-cta">
      <div className="abp-cta__band">
        <div className="abp-cta__grid"></div>
        <div className="abp-cta__inner">
          <div className="abp-cta__badge">{finalCta.badge}</div>
          <h2 className="abp-cta__title">{finalCta.title}</h2>
          <p className="abp-cta__body">{finalCta.body}</p>
          <div className="abp-cta__actions">
            <a href={ctaHref} target="_blank" rel="noopener noreferrer" className="abp-cta-primary">{finalCta.primary} <span className="abp-arrow">&rarr;</span></a>
            <a href={demoHref} target="_blank" rel="noopener noreferrer" className="abp-cta__secondary">{finalCta.secondary}</a>
          </div>
        </div>
      </div>
    </section>
  );
};

/** Slim on-dark footer. */
export const SiteFooter = () => {
  return (
    <footer className="abp-footer">
      <div className="abp-footer__brand">
        <Svg.FooterLogo className="abp-footer__logo" />
      </div>
      <div className="abp-footer__tagline">All-in-one ABA software &mdash; billing, scheduling, data collection &amp; more.</div>
      <div className="abp-footer__copy">&copy; 2026 TherapyLake</div>
    </footer>
  );
};
